const SolidBadgeInfo = ({ classNames }: { classNames: string }) => {
  return (
    <svg
      className={classNames}
      width="340"
      height="420"
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/2000/svg"
      preserveAspectRatio="xMidYMid meet"
      version="1.2"
      viewBox="0 0 340 420"
    >
      <defs>
        <clipPath id="370d0d0804">
          <path
            d="m553.5,198.75l333,0l0,412.5l-333,0l0,-412.5zm0,0"
            id="svg_1"
          />
        </clipPath>
        <clipPath id="b92b6987d5">
          <path
            d="m619.03,258.75l201.75,0l0,201.75l-201.75,0l0,-201.75zm0,0"
            id="svg_2"
          />
        </clipPath>
        <clipPath id="d7bec3a67d">
          <path d="m681.31,328l76.69,0l0,119l-76.69,0l0,-119zm0,0" id="svg_3" />
        </clipPath>
        <clipPath id="a167a72ef3">
          <path d="m703,271.78l46,0l0,46.22l-46,0l0,-46.22zm0,0" id="svg_4" />
        </clipPath>
      </defs>
      <g className="layer">
        <title>Layer 1</title>
        <g
          id="706aa9d626"
          transform="translate(3 1) translate(-509 -207) matrix(1 0 0 1 -44 11)"
        >
          <path
            d="m877.75,363.14c0,43.43 -17.56,82.77 -45.99,111.28c-3.05,3.08 -6.22,6.01 -9.51,8.82c-19.96,17.05 -44.23,29.16 -70.95,34.53c-5.23,1.05 -10.57,1.85 -16,2.36c-5.04,0.5 -10.14,0.75 -15.3,0.75c-5.16,0 -10.26,-0.25 -15.3,-0.75c-5.43,-0.51 -10.75,-1.31 -15.99,-2.36c-26.73,-5.37 -51,-17.48 -70.96,-34.53c-3.29,-2.81 -6.46,-5.74 -9.51,-8.82c-28.43,-28.51 -45.99,-67.85 -45.99,-111.28c0,-87.12 70.63,-157.75 157.75,-157.75c87.13,0 157.75,70.63 157.75,157.75zm0,0"
            fill="#fecd1a"
            fillRule="nonzero"
            id="svg_5"
          />
          <path
            d="m836.54,363.14c0,35.54 -15.91,67.36 -41,88.72c-17.65,15.07 -39.84,24.92 -64.24,27.25c-3.72,0.37 -7.49,0.56 -11.3,0.56c-3.81,0 -7.58,-0.19 -11.3,-0.56c-24.4,-2.33 -46.59,-12.18 -64.23,-27.25c-25.09,-21.36 -41.01,-53.18 -41.01,-88.72c0,-64.36 52.18,-116.53 116.54,-116.53c64.36,0 116.54,52.17 116.54,116.53zm0,0"
            fill="#fecd1a"
            fillRule="nonzero"
            id="svg_6"
          />
          <path
            d="m710.6,413.73c-3.85,0 -7.69,-1.46 -10.62,-4.39l-41.69,-41.7c-5.87,-5.86 -5.87,-15.37 0,-21.24c5.86,-5.86 15.37,-5.86 21.23,0l31.08,31.08l49.88,-49.88c5.86,-5.86 15.37,-5.86 21.23,0c5.87,5.86 5.87,15.38 0,21.24l-60.49,60.5c-2.93,2.93 -6.78,4.39 -10.62,4.39zm0,0"
            fill="#f7f2e2"
            fillRule="nonzero"
            id="svg_7"
          />
          <path
            d="m688.71,517.77l-48.62,86.82l-28.66,-42.29l-51.03,-2.46l47.84,-85.42c3.05,3.08 6.22,6.01 9.51,8.82c19.96,17.05 44.23,29.16 70.96,34.53zm0,0"
            fill="#fecd1a"
            fillRule="nonzero"
            id="svg_8"
          />
          <path
            d="m879.6,559.84l-51.02,2.46l-28.66,42.29l-48.62,-86.82c26.72,-5.37 50.99,-17.48 70.95,-34.53c3.29,-2.81 6.46,-5.74 9.51,-8.82l47.84,85.42zm0,0"
            fill="#fecd1a"
            fillRule="nonzero"
            id="svg_9"
          />
          <path
            d="m755.77,322.9l-45.17,45.17l-26.37,-26.37c-8.45,-8.45 -22.19,-8.45 -30.65,0c-8.44,8.45 -8.44,22.2 0,30.65l41.7,41.69c4.09,4.09 9.53,6.35 15.32,6.35c5.79,0 11.23,-2.26 15.32,-6.35l60.5,-60.5c8.45,-8.45 8.45,-22.19 0,-30.64c-8.45,-8.45 -22.2,-8.45 -30.65,0zm21.24,21.24l-60.49,60.49c-1.59,1.58 -3.68,2.45 -5.92,2.45c-2.24,0 -4.33,-0.87 -5.92,-2.45l-41.69,-41.69c-3.26,-3.26 -3.26,-8.57 0,-11.83c1.63,-1.63 3.78,-2.45 5.92,-2.45c2.14,0 4.28,0.82 5.91,2.45l31.08,31.08c1.24,1.24 2.94,1.94 4.7,1.94c1.77,0 3.46,-0.7 4.7,-1.94l49.88,-49.88c3.26,-3.26 8.57,-3.27 11.83,0c3.26,3.26 3.26,8.57 0,11.83zm0,0"
            fill="#000000"
            fillRule="nonzero"
            id="svg_10"
          />
          <path
            d="m843.19,363.14c0,-67.93 -55.26,-123.19 -123.19,-123.19c-67.93,0 -123.19,55.26 -123.19,123.19c0,36.16 15.8,70.34 43.34,93.78c19.26,16.44 42.74,26.41 67.89,28.82c3.92,0.39 7.95,0.58 11.96,0.58c4.01,0 8.04,-0.19 11.94,-0.58c25.17,-2.41 48.65,-12.37 67.91,-28.81c27.54,-23.45 43.34,-57.63 43.34,-93.79zm-51.98,83.66c-17.16,14.66 -38.1,23.54 -60.56,25.7c-6.98,0.68 -14.3,0.69 -21.32,-0.01c-22.44,-2.14 -43.37,-11.03 -60.55,-25.69c-24.57,-20.92 -38.66,-51.41 -38.66,-83.66c0,-60.59 49.29,-109.88 109.88,-109.88c60.59,0 109.89,49.29 109.89,109.88c0,32.25 -14.1,62.74 -38.68,83.66zm0,0"
            fill="#000000"
            fillRule="nonzero"
            id="svg_11"
          />
          <g clipPath="url(#370d0d0804)" clipRule="nonzero" id="svg_12">
            <path
              d="m885.4,556.58l-45.42,-81.1c28.68,-30.55 44.43,-70.24 44.43,-112.34c0,-90.65 -73.76,-164.4 -164.41,-164.4c-90.65,0 -164.4,73.75 -164.4,164.4c0,42.11 15.75,81.81 44.42,112.34l-45.42,81.1c-1.13,2.01 -1.14,4.46 -0.02,6.48c1.12,2.01 3.2,3.31 5.5,3.42l47.71,2.3l26.8,39.55c1.24,1.83 3.3,2.92 5.5,2.92c0.1,0 0.19,0 0.29,-0.01c2.3,-0.1 4.39,-1.38 5.52,-3.4l46.3,-82.67c3.96,0.68 7.93,1.21 11.84,1.58c5.24,0.52 10.6,0.78 15.96,0.78c5.36,0 10.73,-0.26 15.93,-0.78c3.95,-0.37 7.93,-0.91 11.89,-1.58l46.3,82.67c1.13,2.02 3.22,3.3 5.52,3.4c0.1,0.01 0.19,0.01 0.29,0.01c2.2,0 4.26,-1.09 5.5,-2.92l26.8,-39.55l47.69,-2.3c2.3,-0.11 4.38,-1.41 5.5,-3.42c1.12,-2.02 1.11,-4.47 -0.02,-6.48zm-245.85,35.36l-22.61,-33.38c-1.17,-1.73 -3.09,-2.81 -5.19,-2.91l-40.29,-1.94l38.4,-68.56c1.17,1.06 2.35,2.11 3.57,3.15c18.86,16.11 41.23,27.73 65.15,33.95l-39.03,69.69zm95.1,-78.43c-9.6,0.95 -19.67,0.95 -29.33,0c-5.05,-0.48 -10.2,-1.24 -15.3,-2.26c-25.01,-5.03 -48.5,-16.46 -67.95,-33.07c-3.23,-2.77 -6.3,-5.6 -9.12,-8.45c-28.4,-28.49 -44.04,-66.34 -44.04,-106.59c0,-83.31 67.78,-151.09 151.09,-151.09c83.32,0 151.1,67.78 151.1,151.09c0,40.25 -15.64,78.1 -44.06,106.6c-2.81,2.84 -5.87,5.67 -9.11,8.44c-19.44,16.61 -42.93,28.04 -67.93,33.07c-5.09,1.02 -10.25,1.78 -15.35,2.26zm93.62,42.14c-2.1,0.1 -4.02,1.18 -5.19,2.91l-22.62,33.38l-39.02,-69.7c23.91,-6.21 46.27,-17.83 65.13,-33.94c1.22,-1.04 2.4,-2.09 3.57,-3.15l38.4,68.56l-40.27,1.94zm0,0"
              fill="#000000"
              fillRule="nonzero"
              id="svg_13"
            />
          </g>
          <g clipPath="url(#b92b6987d5)" clipRule="nonzero" id="svg_14">
            <path
              d="m820.77,359.62c0,55.7 -45.17,100.86 -100.87,100.86c-55.71,0 -100.87,-45.16 -100.87,-100.86c0,-55.71 45.16,-100.87 100.87,-100.87c55.7,0 100.87,45.16 100.87,100.87zm0,0"
              fill="#fecd1a"
              fillRule="nonzero"
              id="svg_15"
            />
          </g>
          <path
            d="m738.51,396.14c0,0 4.6,-4.6 3.92,0.38c-0.19,1.34 -0.71,2.62 -1.47,3.74c-3.1,4.56 -13.41,18.32 -28.23,23.76c0,0 -16.3,7.63 -22.35,0c0,0 -7.37,-1.57 0,-22.88c0,0 14.01,-38.26 18.34,-47.92c0.48,-1.06 0.81,-2.18 0.96,-3.33c0.42,-3.27 0.46,-9.05 -5.12,-6.81c-1.33,0.54 -2.51,1.4 -3.52,2.44c-2.81,2.89 -9.83,10.17 -11.71,12.47c0,0 -5.53,6.67 -4.47,-2.32c0,0 8.77,-13.46 27.64,-23.41c0.81,-0.42 1.67,-0.76 2.56,-0.99c4.1,-1.08 15.83,-3.51 20.56,2.52c0,0 7.63,7.89 0.27,24.2l-16.57,43.67c0,0 -5.79,17.89 9.73,4.73l9.46,-10.25zm2.29,-101.76c-6.47,-4.8 -14.35,-2.51 -19.15,3.97c-4.8,6.47 -4.72,14.67 1.76,19.48c6.48,4.81 15.62,3.45 20.42,-3.02c4.8,-6.48 3.45,-15.62 -3.03,-20.43zm0,0"
            fill="#fecd1a"
            fillRule="nonzero"
            id="svg_16"
          />
          <g clipPath="url(#d7bec3a67d)" clipRule="nonzero" id="svg_17">
            <path
              d="m712.38,328.37c6.78,0 13.57,0.28 20.33,-0.07c10.47,-0.55 12.02,6.21 10.96,13.39c-1.29,8.85 -3.37,17.58 -5.01,26.38c-2.67,14.34 -5.3,28.68 -7.87,43.04c-0.37,2.11 -0.51,4.3 -0.48,6.44c0.1,9.47 6.11,13.12 14.69,8.95c2.52,-1.23 4.86,-2.89 7.45,-3.88c1.31,-0.51 3.72,-0.57 4.37,0.22c0.97,1.17 1.48,3.52 0.96,4.92c-0.76,2.06 -2.37,3.97 -4,5.53c-13.38,12.73 -29.51,14.74 -46.63,11.16c-9.47,-1.97 -19.34,-13.28 -17.73,-24.02c2.06,-13.77 4.27,-27.51 6.49,-41.25c1.47,-9.17 3.37,-18.28 4.52,-27.48c1.06,-8.38 -1.15,-10.67 -9.56,-11.49c-0.83,-0.08 -1.68,-0.01 -2.47,-0.2c-3.33,-0.83 -6.71,-2.02 -6.77,-6.08c-0.07,-4.43 3.57,-5.31 6.96,-5.4c7.92,-0.21 15.86,-0.07 23.79,-0.07c0,-0.03 0,-0.06 0,-0.09"
              fill="#000000"
              fillRule="nonzero"
              id="svg_18"
            />
          </g>
          <g clipPath="url(#a167a72ef3)" clipRule="nonzero" id="svg_19">
            <path
              d="m748.2,295.14c-0.11,12.67 -10.28,22.88 -22.7,22.82c-12.52,-0.07 -22.54,-10.67 -22.34,-23.67c0.2,-12.76 10.17,-22.49 22.93,-22.36c12.51,0.13 22.23,10.33 22.11,23.21"
              fill="#000000"
              fillRule="nonzero"
              id="svg_20"
            />
          </g>
        </g>
      </g>
    </svg>
  );
};

export default SolidBadgeInfo;
